/**
 * @component {"type":"DiplomaButton","version":"1.2"}
 */

define('component-diploma',['knockout', 'helpers'], function (ko, helpers) {

    return function (parentVM, dataContext) {
        var self = this,
            entityVM = parentVM.entity,

            // Count user hour offset
            d = new Date(),
            off = d.getTimezoneOffset(),
            hourOff = Math.abs(off / 60),
            diplomaUrlStr = dataContext.diplomaURL + '?hourOffset=' + hourOff,
            diplomaEmailUrl = dataContext.diplomaEmailURL,
            content;

        self.exists = ko.observable(false);
        self.emailForm = ko.observable(false);
        self.emailBtnLabel = ko.observable();
        self.dynamicRecipients = ko.observable(false);
        self.emailBtnDisabled = ko.observable(false);

        self.content = ko.computed(function () {
            return helpers.component.getContent(entityVM.componentsJSON(), 'DiplomaButton');
        });

        self.url = ko.computed(function () {
            if (Object.keys(getCustomTexts()).length) diplomaUrlStr += '&customTexts=' + encodeURIComponent(JSON.stringify(getCustomTexts()));
            return diplomaUrlStr;
        });

        self.emailInstructions = ko.computed(function() {
            return self.content().emailInstructions || '';
        });

        self.label = ko.computed(function () {
            return self.content().buttonLabel || '';
        });

        function getEmailRecipients() {
            return self.content().emailRecipient || document.getElementById('diploma-recipients').value;
        }

        function getCustomTexts() {
            var obj = {},
                arr = helpers.component.parseProp(self.content(), 'items', 'DiplomaText');

            if (!arr.length) {
                return obj;
            }

            for (var i = 0; i < arr.length; i++) {
                if (arr[i] && arr[i].id && arr[i].text) {
                    obj[arr[i].id] = helpers.misc.replaceTextholder(parentVM.training, parentVM.user, arr[i].text).replace(/<[^>]+>/g, '');
                }
            }
            return obj;
        }

        self.sendDiplomaAsEmail = function () {
            var diplomaEmailData = {
                    trainingId: dataContext.trainingID,
                    sender: self.content().emailSender,
                    recipients: getEmailRecipients().split(';').join(',').split(','),
                    subject: self.content().emailTitle,
                    body: helpers.misc.replaceTextholder(parentVM.training, parentVM.user, self.content().emailBody),
                    isBodyHtml: true,
                    customTexts: JSON.stringify(getCustomTexts()),
                    diplomaName: dataContext.learning.training.name.replace(/[^a-z0-9]/gi, '_').toLowerCase() + '-diploma'
                },

                request = new Request(diplomaEmailUrl, {
                    method: 'post',
                    headers: new Headers({'Authorization-Token': dataContext.tokenID, "Content-Type": "application/json"}),
                    body: JSON.stringify(diplomaEmailData)
                });

            self.emailBtnLabel(self.content().sendButtonLabelSending || '');
            self.emailBtnDisabled(true);

            fetch(request)
                .then(function (response) {
                    if (response.status === 200) {
                        self.emailBtnLabel(self.content().sendButtonLabelSuccess ||'');
                    } else {
                        self.emailBtnLabel(self.content().sendButtonLabelFailed || '');
                    }
                    setTimeout(function() {
                        self.emailBtnDisabled(false);
                        self.emailBtnLabel(self.content().sendButtonLabel || '');
                    }, 3000);
                })
        };

        function init() {
            self.emailBtnLabel(self.content().sendButtonLabel || '');
            self.emailForm(self.content().sendAsEmail);
            self.dynamicRecipients(!self.content().emailRecipient);
        }

        self.pageChanged = ko.computed(function(){
            var entityID = parentVM.entity.ID(); // eslint-disable-line
            self.exists(!!parentVM.training.getComponentsByKind('DiplomaButton')[0]);
            if (self.exists()) {
                init();
            }
        });
    };

});

